import { render, staticRenderFns } from "./OnboardStep.vue?vue&type=template&id=2a1dbcbb&scoped=true"
import script from "./OnboardStep.vue?vue&type=script&lang=js"
export * from "./OnboardStep.vue?vue&type=script&lang=js"
import style0 from "./OnboardStep.vue?vue&type=style&index=0&id=2a1dbcbb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a1dbcbb",
  null
  
)

export default component.exports